import { Camera, Scene } from 'three'

export enum EVENTS {
  FADE_IN_COMPLETED = 'FADE_PLUGIN:FADE_IN_COMPLETED',
  FADE_OUT_COMPLETED = 'FADE_PLUGIN:FADE_OUT_COMPLETED',
}

export type TransitionConfig = {
  duration?: number
  color?: string | number
}

export type FadeInProps = {
  camera: Camera
  scene: Scene
} & TransitionConfig

export type FadeOutProps = {
  camera: Camera
  scene: Scene
} & TransitionConfig
